import {
  WLCommonPromiseReturn,
  doPost,
  getRequestHeaders,
} from "../../Common/utils/https";
import { cloudFunctionsUrl } from "../firebase";

const baseUrl = cloudFunctionsUrl;

/**
 *
 * @param phoneNumber
 * @returns
 */
export const sendSMSVerification = async (
  phoneNumber: string
): Promise<WLCommonPromiseReturn> => {
  const url = `${baseUrl}otp/sendSMSVerification`;
  const headers = await getRequestHeaders(true);
  console.log("sending token", headers);
  return doPost(url, headers, { phoneNumber });
};

export const checkSMSVerification = async ({
  phoneNumber,
  code,
}: {
  phoneNumber: string;
  code: string;
}) => {
  const url = `${baseUrl}otp/checkSMSVerification`;
  const headers = await getRequestHeaders();
  return doPost(url, headers, { phoneNumber, code });
};
